import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-pick-a-dentist-header',
  templateUrl: './pick-a-dentist-header.component.html',
  styleUrls: ['./pick-a-dentist-header.component.css']
})
export class PickADentistHeaderComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
